import { widgetEnum } from './constants.js'
const findByLayoutId = (layoutId, children, app) => {
  const isDesktop = app?.env?.isDesktop()
  const isMobile = app?.env?.isMobile()

  return children
    .filter(c => ((isDesktop && isDesktopWidget(c)) || (isMobile && isMobileWidget(c))) &&
      (c?.props?.layoutId === layoutId))
}

const isDesktopWidget = (el) => {
  const widgetType = el?.props?.widgetType
  // if widgetType is undefined, then assume component can show for both desktop and mobile
  if (widgetType === widgetEnum.Desktop || !widgetType) return true
  return false
}

const isMobileWidget = (el) => {
  const widgetType = el?.props?.widgetType
  if (widgetType === widgetEnum.Mobile || !widgetType) return true
  return false
}

export default findByLayoutId
